import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import { useEffect } from "react";

export default function NotFound() {
    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <Helmet>
                <title>404 — Страница не найдена</title>
                <meta name="robots" content="noindex" />
                <meta name="prerender-status-code" content="404"></meta>
            </Helmet>
            <h1>404</h1>
            <p>Страница не найдена</p>
            <Link to={"/"}>
                <button>Вернуться на главную</button>
            </Link>
        </div>
    );
}